export const ACTIVATION_ERROR = {
  LOGGED_OUT: 'You are not logged in on this device. Click here to sign in.',
  INVALID: 'Invalid or expired code. Double check your entry.',
} as const;

export function getHumanReadableErrorMessage(error: string) {
  let legibleError = error;
  if (error.match(/invalid/i)) {
    legibleError = ACTIVATION_ERROR.INVALID;
  } else if (error.match(/signed/i)) {
    legibleError = ACTIVATION_ERROR.LOGGED_OUT;
  }
  return legibleError;
}
